import axios from '@/services/api';


export const getReserves = async ({ commit }, params) => {
    commit('setReserves', []);
    const response = await axios.get('/reserves', { params: params})

    const { data } = response;

    try {
        if (data) {
            commit('setReserves', data);
        }

    } catch (e) {
        console.log(e);
    }

};

export const getReserveById = async ({ commit }, id) => {
    commit('setCurrentReserve', null);
    const response = await axios.get(`/reserves/${id}`)

    const { data } = response;

    try {
        if (data) {
            commit('setCurrentReserve', data);
        }

    } catch (e) {
        console.log(e);
    }
}

export const add = async (_, payload) => {
    return await axios.post("reserves", payload)
        .then((response) => response)
        .catch((e) => e.response);
};

export const edit = async (_, payload) => {

    return await axios.put("reserves/" + payload.id, payload)
        .then((response) => response)
        .catch((e) => e.response);
};

export const deleteReserve = async ({ commit }, id) => {

    await axios.delete(`/reserves/${id}`)

    try {
        commit('setLoading', false);
    } catch (e) {
        console.log(e);
    }
};

